module.exports = __webpack_public_path__ + "img/company5.f4e2da2d.png";